var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"default"}},[_c('v-content',[_c('v-fade-transition',[(_vm.fullLoading)?_c('div',{staticClass:"loaderOverlay"},[_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')])]):_vm._e()]),(_vm.$route.path != '/login')?_c('app-bar'):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }